import { render, staticRenderFns } from "./NationalTrademarkNoteTypeForm.vue?vue&type=template&id=f33bba34&"
import script from "./NationalTrademarkNoteTypeForm.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkNoteTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkNoteTypeForm.vue?vue&type=style&index=0&id=f33bba34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports